export default "__VITE_ASSET__b6eba7cf__"